import { titulosApi } from "../view/titulos.service";

export const downloadTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    downloadTitulo: builder.query({
      query: (id) => ({
        url: `/v1/api/titulo/${id}/download/`,
        method: "GET",
      }),
    }),
  }),
});

export const { useDownloadTituloQuery, useLazyDownloadTituloQuery } = downloadTitulo;
